import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import FullLogoImage from '../../assets/images/full-logo.svg';

const useStyles = makeStyles(({ palette }) => ({
  text: {
    color: palette.common.black,
    fontSize: '2rem',
    fontWeight: 300,
    lineHeight: '2.5rem',
  },
}));

export interface IAlyceLoadingProps {
  text?: string;
}

const AlyceLoading = ({ text = 'Loading...' }: IAlyceLoadingProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Box
      height="100vh"
      width="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      bgcolor="common.white"
      mt={1}
    >
      <Box mb={2} width={118}>
        <img src={FullLogoImage} alt="Loading..." />
      </Box>
      <Box mb={2}>
        <Typography className={classes.text}>{text}</Typography>
      </Box>
      <CircularProgress />
    </Box>
  );
};

export default AlyceLoading;
